import { Component, OnInit, Input, SimpleChanges } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ObjectenService } from 'src/app/shared/dataservices/objecten.service';
import { RelatiesService } from 'src/app/shared/dataservices/relaties.service';
import { ObjectAfleveradres } from 'src/app/shared/model/object';
import { AfleverAdres } from 'src/app/shared/model/relatie';

@Component({
  selector: 'app-objectafleveradres-list',
  templateUrl: './afleveradres-list.component.html',
  styleUrls: ['./afleveradres-list.component.less']
})
export class ObjectAfleveradresListComponent implements OnInit {

  @Input() objectid : number;
  @Input() relatieid : number;

  objectafleveradreslist : Array<ObjectAfleveradres> = null;
  afleveradressen : Array<AfleverAdres> = null;
  adresSelectedID : number = null;




  constructor(private objectenService: ObjectenService,
              private relatieService : RelatiesService,
              private toastr: ToastrService ) { }

  ngOnInit() {
  }

  /* objectid changes */
  ngOnChanges(changes: SimpleChanges) {
    this.objectenService.getObjectAfleveradresList(this.objectid).subscribe(data => {
      this.objectafleveradreslist = data as Array<ObjectAfleveradres>;
    })
    this.relatieService.getAfleveradressen(this.relatieid).subscribe(data => {
      this.afleveradressen = data as Array<AfleverAdres>;
    })
  }

  addNew() {
    if (this.adresSelectedID == null) {
      this.toastr.error("", "Geen adres geselecteerd");
    }

    let objectAdres = new ObjectAfleveradres();
    objectAdres.AfleverAdresID = this.adresSelectedID;
    objectAdres.ObjectID = this.objectid;
    this.objectenService.postObjectAfleveradres(objectAdres).subscribe(data => {
        objectAdres.ID = data.id;
        this.objectafleveradreslist.push(objectAdres);
    });



    // var afleveradres = new ObjectAfleveradres();
    // afleveradres.ID = null;
    // afleveradres.ObjectID = this.objectid;
    // this.objectafleveradreslist.push(afleveradres);
  }

  deleted(id: any) {
    this.objectafleveradreslist.forEach( (item, index) => {
      if(item.ID === id) {
        this.objectafleveradreslist.splice(index,1);
      }
  });
  }

  getAdres(AfleverAdresID :number) {
    let adres = new AfleverAdres()
    if (this.afleveradressen)
        adres = this.afleveradressen.find(a => a.ID === AfleverAdresID);
    return adres;
  }

}
